import { RawTask } from '@types';

import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetInitiativeTasksRequest = KeyPaginationQueryParams & {
	initiativeId: number;
};

export type GetInitiativeTasksResponse = PaginatedResource<RawTask>;

export const getInitiativeTasks = createGetEndpoint<GetInitiativeTasksRequest, GetInitiativeTasksResponse>(
	({ initiativeId, ...rest }) => `/api/v3/initiatives/${initiativeId}/tasks?${getQueryString(rest)}`
);
